module.exports = __webpack_public_path__ + "img/0.6ccde79c.jpg";